import { render, staticRenderFns } from "./ModalCategories.vue?vue&type=template&id=b2bf7010&scoped=true&lang=pug&"
import script from "./ModalCategories.vue?vue&type=script&lang=js&"
export * from "./ModalCategories.vue?vue&type=script&lang=js&"
import style0 from "./ModalCategories.vue?vue&type=style&index=0&id=b2bf7010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bf7010",
  null
  
)

export default component.exports